import getLoadBalancedUrl from 'utils/cdn/getLoadBalancedUrl';
import * as constants from '../../../constants/constants';

const getFallbackImage = (key: string): string => {
  if (key === 'placeholderImage') return constants.placeholderImage;

  return constants.defaultImage;
};

const getSrc = ({
  url,
  imagecachePreset,
  fallbackImage,
}: {
  url: string;
  imagecachePreset?: string;
  fallbackImage: string;
}) => {
  const defaultImage = getFallbackImage(fallbackImage);

  if (!url) {
    return defaultImage;
  }

  const regex = /.*\/\/[^/]*(\/.*)$/;
  const match = RegExp(regex).exec(url);
  const s3Path = match ? match[1] : '';

  if (!s3Path) {
    return defaultImage;
  }

  try {
    if (!imagecachePreset) {
      return getLoadBalancedUrl(url, s3Path);
    }

    // Make an imagecache URL to use
    return getLoadBalancedUrl(url, `/imagecache/${imagecachePreset}${s3Path}`);
  } catch {
    return defaultImage;
  }
};

export default getSrc;
